const STORAGE_KEY='sm-customer-operations-workspace-zoom';
const LEGACY_STORAGE_KEY='sm-customer-operations-display-scale';
export const MIN_ZOOM=80,MAX_ZOOM=150,ZOOM_STEP=10;
export const WORKSPACE_ZOOMS=[80,90,100,110,120,130,140,150];
export const DISPLAY_SCALES=[
  {key:'standard',label:'Standard · 100%',scale:1},
  {key:'comfortable',label:'Comfortable · 110%',scale:1.1},
  {key:'large',label:'Large · 120%',scale:1.2},
  {key:'extra-large',label:'Extra large · 130%',scale:1.3}
];
const legacy={standard:100,comfortable:110,large:120,'extra-large':130};
let desiredZoom=100,nativeQueue=Promise.resolve(),initialised=false;

export function normaliseWorkspaceZoom(value){
  const n=Number(value);return Number.isFinite(n)&&n>0?Math.max(MIN_ZOOM,Math.min(MAX_ZOOM,Math.round(n/ZOOM_STEP)*ZOOM_STEP)):100;
}
export function getWorkspaceZoom(){
  try{
    const saved=localStorage.getItem(STORAGE_KEY);
    if(saved!==null)return normaliseWorkspaceZoom(saved);
    return legacy[localStorage.getItem(LEGACY_STORAGE_KEY)]||100;
  }catch{return 100;}
}
export function getCssWorkspaceZoom(){
  return Number(document.documentElement.style.zoom)||1;
}
function viewportSize(){
  const scale=getCssWorkspaceZoom(),root=document.documentElement;
  const viewport=window.visualViewport;
  root.style.setProperty('--crm-viewport-height',String((viewport?.height||window.innerHeight)/scale)+'px');
  root.style.setProperty('--crm-viewport-width',String((viewport?.width||window.innerWidth)/scale)+'px');
}
function cssZoom(percentage){
  const root=document.documentElement;root.style.zoom=String(percentage/100);
  root.style.setProperty('--crm-display-scale',String(percentage/100));
  viewportSize();
}
export function applyWorkspaceZoom(value){
  desiredZoom=normaliseWorkspaceZoom(value);
  const root=document.documentElement;
  root.dataset.workspaceZoom=String(desiredZoom);
  const invoke=window.__TAURI__?.core?.invoke;
  if(typeof invoke!=='function'){
    delete root.dataset.nativeDisplayZoom;cssZoom(desiredZoom);return Promise.resolve(desiredZoom);
  }
  // Serialise native updates; CSS is neutral while native zoom is pending or active.
  cssZoom(100);
  nativeQueue=nativeQueue.catch(()=>{}).then(async()=>{
    const percentage=desiredZoom;
    root.dataset.nativeDisplayZoom='pending';
    try{
      await invoke('set_workspace_zoom',{zoomFactor:percentage/100});
      root.dataset.nativeDisplayZoom='true';cssZoom(100);
    }catch{
      delete root.dataset.nativeDisplayZoom;cssZoom(desiredZoom);
    }
    return desiredZoom;
  });
  return nativeQueue;
}
export function setWorkspaceZoom(value){
  const next=normaliseWorkspaceZoom(value);
  void applyWorkspaceZoom(next);
  try{localStorage.setItem(STORAGE_KEY,String(next));}catch{}
  window.dispatchEvent(new CustomEvent('crm-workspace-zoom-change',{detail:{percentage:next}}));
  return next;
}
export const incrementWorkspaceZoom=()=>setWorkspaceZoom(getWorkspaceZoom()+ZOOM_STEP);
export const decrementWorkspaceZoom=()=>setWorkspaceZoom(getWorkspaceZoom()-ZOOM_STEP);
export const resetWorkspaceZoom=()=>setWorkspaceZoom(100);
export function handleWorkspaceZoomShortcut(event){
  if(event.altKey||(!event.ctrlKey&&!event.metaKey))return false;
  let action;
  if(event.key==='-'||event.key==='_')action=decrementWorkspaceZoom;
  else if(event.key==='+'||event.key==='=')action=incrementWorkspaceZoom;
  else if(event.key==='0')action=resetWorkspaceZoom;
  else return false;
  event.preventDefault();event.stopPropagation();action();return true;
}
export function initialiseWorkspaceZoom(){
  const next=getWorkspaceZoom();
  try{localStorage.setItem(STORAGE_KEY,String(next));}catch{}
  void applyWorkspaceZoom(next);
  if(!initialised){
    window.addEventListener('keydown',handleWorkspaceZoomShortcut,true);
    window.addEventListener('resize',viewportSize);
    window.visualViewport?.addEventListener('resize',viewportSize);
    window.addEventListener('storage',event=>{if(event.key===STORAGE_KEY){void applyWorkspaceZoom(getWorkspaceZoom());window.dispatchEvent(new CustomEvent('crm-workspace-zoom-change',{detail:{percentage:getWorkspaceZoom()}}));}});
    initialised=true;
  }
  return next;
}
// Compatibility for existing imports; new controls always use workspace percentages.
export const getDisplayScalePreference=getWorkspaceZoom;
export const applyDisplayScalePreference=value=>applyWorkspaceZoom(legacy[value]||value);
export const setDisplayScalePreference=value=>setWorkspaceZoom(legacy[value]||value);
export const initialiseDisplayScale=initialiseWorkspaceZoom;
